import PropTypes from 'prop-types'
import React from 'react'
import { get } from 'lodash'

import FiltersCategory from './filtersCategory'
import FiltersTags from './filtersTags'
import FiltersPrice from './filtersPrice'
import FiltersCompatibleWith from './filtersCompatibleWith'
import FiltersSoftwareVersion from './filtersSoftwareVersion'
import FiltersPolygons from './filtersPolygons'
import FiltersFileType from './filtersFileType'
import SelectedFilters from './selectedFilters'
import FiltersSize from './filtersSize'
import FiltersColors from './filtersColors'
import FiltersLength from './filtersLength'
import FiltersVocals from './filtersVocals'
import FiltersDropdown from './filtersDropdown'
import FiltersBoolean from './filtersBoolean'
import FiltersProMusic from './filtersProMusic'

const SearchFilters = ({ aggregations, location, currentSite }) => {
  const basicFilters = [
    {
      Component: FiltersCategory,
      isActive: !!get(aggregations, 'category.length'),
      props: {
        categoryRootCount: get(aggregations, 'category_root_count.count'),
        items: aggregations.category
      }
    },
    {
      Component: FiltersTags,
      isActive: !!get(aggregations, 'tags.length'),
      props: {
        items: aggregations.tags
      }
    },
    {
      Component: FiltersPrice,
      isActive: true,
      props: {
        cost: aggregations.cost
      }
    },
    {
      Component: FiltersDropdown,
      isActive: true,
      props: {
        name: 'sales',
        label: 'Sales',
        ignoreOptions: ['varies'],
        items: aggregations.sales_count
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'rating.length') > 0,
      props: {
        name: 'rating_min',
        label: 'Rating',
        prependShowAllOption: false,
        items: aggregations.rating
      }
    }
  ]

  const extraFilters = [
    {
      Component: FiltersBoolean,
      isActive: get(aggregations, 'hosting_setup.count') > 0,
      props: {
        name: 'hosting_setup',
        label: 'Hosting & Setup',
        count: get(aggregations, 'hosting_setup.count')
      }
    },
    {
      Component: FiltersSoftwareVersion,
      isActive: get(aggregations, 'platform.length') > 0,
      props: {
        items: aggregations.platform,
        platformRootCount: get(aggregations, 'platform_root_count.count')
      }
    },
    {
      Component: FiltersCompatibleWith,
      isActive: get(aggregations, 'compatible_with.length') > 0,
      props: {
        items: aggregations.compatible_with
      }
    },
    {
      Component: FiltersPolygons,
      isActive: aggregations.poly_count,
      props: {
        items: aggregations.poly_count
      }
    },
    {
      Component: FiltersFileType,
      isActive: get(aggregations, 'file_formats.length') > 0,
      props: {
        items: aggregations.file_formats
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'orientation.length') > 0,
      props: {
        name: 'orientation',
        label: 'Orientation',
        items: aggregations.orientation
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'resolution.length') > 0,
      props: {
        name: 'resolution_min',
        label: 'Minimum resolution',
        items: aggregations.resolution
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'frame_rate.length') > 0,
      props: {
        name: 'frame_rate',
        label: 'Frame rate',
        items: aggregations.frame_rate
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'requires_plugins.length') > 0,
      props: {
        name: 'requires_plugins',
        label: 'Requires Plugins',
        items: aggregations.requires_plugins
      }
    },
    {
      Component: FiltersSize,
      isActive: get(aggregations, 'size.length') > 0,
      props: {
        items: aggregations.size
      }
    },
    {
      Component: FiltersColors,
      isActive: get(aggregations, 'colors.length') > 0,
      props: {
        items: aggregations.colors
      }
    },
    {
      Component: FiltersLength,
      isActive: !!aggregations.length,
      props: {
        length: aggregations.length
      }
    },
    {
      Component: FiltersVocals,
      isActive: get(aggregations, 'vocals_in_audio.length') > 0,
      props: {
        items: aggregations.vocals_in_audio
      }
    },
    {
      Component: FiltersDropdown,
      isActive: get(aggregations, 'tempo.length') > 0,
      props: {
        name: 'tempo',
        label: 'Tempo',
        ignoreOptions: ['varies'],
        items: aggregations.tempo
      }
    },
    {
      Component: FiltersBoolean,
      isActive: !!aggregations.alpha,
      props: {
        name: 'alpha',
        label: 'Alpha channel',
        count: get(aggregations, 'alpha.count')
      }
    },
    {
      Component: FiltersBoolean,
      isActive: !!aggregations.looped,
      props: {
        name: 'looped',
        label: 'Looped',
        count: get(aggregations, 'looped.count')
      }
    },
    {
      Component: FiltersProMusic,
      isActive: currentSite === 'audiojungle'
    }
  ]

  const activeBasicFilters = basicFilters.filter(filter => filter.isActive)
  const activeExtraFilters = extraFilters.filter(filter => filter.isActive)

  return (
    <div
      className="search-facet-panel"
      data-test-selector="search-filters-default"
    >
      <SelectedFilters location={location} currentSite={currentSite} />
      <div className="search-facet fds-u-is-hidden--no-js">
        {activeBasicFilters.map((filter, index, list) => {
          return (
            <filter.Component
              key={index}
              location={location}
              isAtTop={index === 0}
              isAtBottom={list.length === index + 1}
              {...filter.props}
            />
          )
        })}
      </div>

      {!!activeExtraFilters.length && (
        <div className="search-facet fds-u-is-hidden--no-js">
          {activeExtraFilters.map((filter, index, list) => {
            return (
              <filter.Component
                key={index}
                location={location}
                isAtTop={index === 0}
                isAtBottom={list.length === index + 1}
                {...filter.props}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

SearchFilters.propTypes = {
  aggregations: PropTypes.object,
  location: PropTypes.object.isRequired,
  currentSite: PropTypes.string
}

SearchFilters.defaultProps = {
  aggregations: {}
}

export default SearchFilters



// WEBPACK FOOTER //
// ./client/components/filters/searchFilters.js